import { AxiosResponse } from "axios";

import { removeEmpty } from "../../utils/removeEmpty";
import { ApiPesquisa } from "../../Apis/Pesquisa";
import {
  IDenunciaDTO,
  IGetDenunciasProps,
  IPageDenunciaDTO,
} from "../../types/denuncia";

const basePath = "/denuncia";

export class Denuncia {
  static async get(
    props?: IGetDenunciasProps
  ): Promise<AxiosResponse<IPageDenunciaDTO>> {
    let params = "";
    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values).toString();
    }
    return ApiPesquisa.get(params ? `${basePath}?${params}` : basePath);
  }

  static async getById({
    uuidDenuncia,
  }: {
    uuidDenuncia: string;
  }): Promise<AxiosResponse<IDenunciaDTO>> {
    return ApiPesquisa.get(`${basePath}/${uuidDenuncia}`);
  }
}
